<template>
  <div class="container">
    <!-- 保修列表 -->
    <div class="scroll-y">
      <div
        class="consult-list"
        v-for="item in consultationList"
        :key="item.maintenanceFormId"
        @click="hanleGoPageClick(item.id)"
      >
        <div class="consult-list-type">报修类型：{{item.type}}</div>
        <div class="consult-list-time">申请时间：{{item.applyDate}}</div>
      </div>
    </div>
    <!-- 保修按钮 -->
    <div class="consult-btn" @click="handleGoPageNewClick">新建咨询</div>
  </div>
</template>
<script>
import { ConsultaionList } from "@/api/consultation";
export default {
  data() {
    return {
      consultationList: []
    };
  },
  mounted() {
    this.requestConsultaionList();
  },
  methods: {
    // 获取资讯列表
    requestConsultaionList() {
       if(this.$cookies.get('internetBarId')) {
          var internetBarId =  this.$cookies.get('internetBarId')
        }else {
          var internetBarId = sessionStorage.getItem('internetBarId')    
        }
      ConsultaionList({internetBarId:internetBarId}).then(res => {
        console.log(res);
        this.consultationList = res.data;
      });
    },
    // 跳转详情
    hanleGoPageClick(id) {
      console.log(id);
      this.$router.push({
        path: "/consultdetails",
        query: {
          id: id
        }
      });
    },
    // 新建咨询
    handleGoPageNewClick() {
      this.$router.push({
        path: "/consultnew"
      });
    }
  }
};
</script>
<style lang="scss" scoped>
// $percentage
// 状态颜色处理
.red-color {
  color: #ff3838;
}
.gray-color {
  color: #999999;
}
.yellow-color {
  color: #ffaa00;
}
.blue-color {
  color: #008cff;
}
.container {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
  .scroll-y {
    width: 100%;
    height: 89%;
    background-color: #f6f6f6;
    overflow-x: hidden;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  // 列表内容
  .consult-list {
    width: 350px;
    height: 80px;
    background-color: $white-color;
    margin: 10px 13px;
    border-radius: 8px;
    font-size: 14px;
    text-align: left;
    .consult-list-type {
      padding: 15px 15px;
      box-sizing: border-box;
    }
    .consult-list-time {
      padding: 3px 15px;
      box-sizing: border-box;
    }
  }
  // 按钮
  .consult-btn {
    width: 350px;
    height: 44px;
    background: -webkit-linear-gradient(left, #05aefc, #008cff);
    margin: 0 auto;
    border-radius: 22px;
    font-size: 16px;
    color: $white-color;
    line-height: 44px;
    position: fixed;
    bottom: 20px;
    left: 50%;
    margin-left: -175px;
  }
}
</style>